import request from "@/utils/request.js"

// 寻宝活动-添加|修改
export const addTreasureActivity = (formData) => {
    return request.post('/management/treasure-activity', formData)
}

// 寻宝活动-详情
export const detailTreasureActivity = (goodsId) => {
    return request.get(`/management/treasure-activity/${goodsId}`)
}

// 寻宝活动列表
export const listTreasureActivity = (pageData, formData) => {
    return request.post(`/management/treasure-activity/${pageData.page}/${pageData.pageSize}`, formData)
}

// 寻宝活动-置顶
export const setTopTreasureActivity = (goodsId, updateData) => {
    return request.put(`/management/treasure-activity/setTop/${goodsId}?isTop=${updateData.isTop}`)
}

// 寻宝活动详情-报名人列表
export const listTreasureActivityParticipant = (pageData, formData) => {
    return request.get(`/management/treasure-activity/participant/${formData.goodsId}/${pageData.page}/${pageData.pageSize}`, {params: {orderStateList: formData.orderStateList}})
}

// 修改寻宝活动状态
export const updateTreasureActivityState = (goodsId, treasureActivityState) => {
    return request.put(`/management/treasure-activity/treasureActivityState?goodsId=${goodsId}&treasureActivityState=${treasureActivityState}`)
}

// 寻宝活动详情-报名人员下载
export const downloadTreasureActivityParticipant = (pageData, formData) => {
    return request.post(`/management/treasure-activity/download/participant`, {params: formData})
}
